import { render, staticRenderFns } from "./supplier-product-list.vue?vue&type=template&id=5843c50b"
import script from "./supplier-product-list.vue?vue&type=script&lang=js"
export * from "./supplier-product-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports